export const FILE_NAMES = {
    recentReleases: '/LocusOverSight/V2/WebApp/Oversight%20Mobile%20Push%20Notifications%20.pdf',
    termsAndConditions: '/documents/masterservicesagreementforoversight-en-gb-5523044.pdf',
    cfaSupplierTG: '/LocusOverSight/V2/WebApp/Chick-fil-A -GO Tracker and Oversight - Supplier Training 91620.pdf',
    cfaDistributionCenterTG: '/LocusOverSight/V2/WebApp/Chick-fil-A Custom Distribution Training Guide - 92220.pdf',
    cfaRedistributionTG: '/LocusOverSight/V2/WebApp/Chick-fil-A Armada Training Guide - 82020.pdf',
    cfaDirectTG: '/LocusOverSight/V2/WebApp/Chick-Fil-A_XL Dairy 83120.pdf',
    cfaNondirectTG: '/LocusOverSight/V2/WebApp/Chick-Fil-A_XL Frozen Sausage 83120.pdf',
};
